module.exports = __webpack_public_path__ + "static/media/009_recontract@2x.c1a2174f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/009_recontract@2x.png
// module id = 571
// module chunks = 0